import React from 'react';

import { Typography, Row, Col } from 'antd';

import Datepicker from './Datepicker';
import Rangepicker from './Rangepicker';

import commonConfig from '../../../commonConfig.json';

const { Text } = Typography;
let datePickerConfigs = commonConfig.datePickerProps;

const CustomDatepicker = props => {
    let label = <Text disabled={props.disabled} strong>{props.labelName}</Text>
    let picker = "";
    if (props.mode === datePickerConfigs.mode.SINGLE) {
        picker = <Datepicker {...props}></Datepicker>
    } else if (props.mode === datePickerConfigs.mode.RANGE) {
        picker = <Rangepicker {...props}></Rangepicker>
    }

    if (props.labelPosition === datePickerConfigs.labelPosition.VERTICAL) {
        return (
            <Col span={24}>
                {label}
                {picker}
            </Col>
        )
    } else {
        return (
            <Row>
                <Col span={12}>
                    {label}
                </Col>
                <Col span={12}>
                    {picker}
                </Col>
            </Row>
        )
    }
}

export default React.memo(CustomDatepicker);